import React from 'react';
import { useTranslation } from 'react-i18next';

import classes from './Card.module.css';
import Button from '../Button/Button';

const Card = (props) =>{
    const {t} = useTranslation('global');

    const messageClasses = [
      classes[`${props.origin}-message`],
      classes.Card
    ];

    const clickHandler = (value, action) => {
      if (value) props.selected(value);
    }

    let buttons = '';

    buttons = props.payload.buttons.map((btn, index) => (
      <li key={index}>
        <Button 
          title= {btn.title}
          value={btn.value} 
          action={btn.action}
          type= {btn.type}
          style= {props.buttonStyle}
          click= {clickHandler}/>
      </li>
    ))

    const image = (
      props.payload.image ? 
        <div className={classes.Image}>
          <img src={props.payload.image} alt={props.payload.title} aria-label={t('card.image')}/>
        </div>
      : ''
    );

    const title = (
      props.payload.title ?
        <div className={classes.Title} aria-labelledby="cardTitle">  
        <h4 id="cardTitle" className="sr-only"> {t('card.title')} </h4>
          {props.payload.title}
        </div>
      : ''
    );

    const description = (
      props.payload.description ?
        <div className={classes.Description} aria-labelledby="cardDescription">  
          <h4 id="cardDescription" className="sr-only"> {t('card.description')} </h4>
          <span dangerouslySetInnerHTML={{__html: props.payload.description}} />
        </div>
      : ''
    );

    const buttonContainer = (
      props.payload.buttons.length ?
        <ul className={classes.Buttons} aria-labelledby="cardButtons">  
        <h4 id="cardButtons" className="sr-only"> {t('card.buttons')} </h4>
          {buttons}
        </ul>
      : ''
    );

    return (
      <div 
        className={messageClasses.join(' ')} 
        style={props.style} 
        role="region" 
        tabIndex='0'
        aria-labelledby="carHeader">   
        <h4 id="carHeader" className="sr-only"> {t('card.header')} </h4>
 
     
        {image}

        <div className={classes.Info}>
          {title}
          {description}
          {buttonContainer}
        </div>
      </div>
    )
  
  
}



export default Card;